module.exports = __webpack_public_path__ + "static/media/timelapse.7d774654.mp4";